import { lazy } from 'react'

export const BetweenMealsV1 = lazy(() => import('./v1/BetweenMealsV1'))
